<ng-container *ngIf="isLoading" style="margin-top: 20px">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>

<ng-container *ngIf="!isLoading">
  <summit-web-user-info
    [restfulServicesUrl]="environment.restfulService"
    [isProduction]="environment.isNotLocalhost"
    [webUser]="webUser"
    [accessLevel]="accessLevelEnum.EDIT_NO_ADMIN"
    [hasProducerAccount]="hasProducerAccount"
    (isUserValid)="isUserValid = $event"
    (hasChanges)="webUserInfoChanged()"
    (profileTypeChanged)="updateProfileType($event)">
  </summit-web-user-info>

  <summit-web-user-accounts *ngIf="profileType"
    [profileType]="profileType"
    [webUser]="webUser"
    [accessLevel]="accessLevelEnum.EDIT_NO_ADMIN"
    (hasProducerAccount)="hasProducerAccount = $event"
    (addAccountActivityNote)="profileChangeHistoryService.addAccountActivityNote($event, authService.getUserName())"
    (hasUnsavedChanges)="isAdding = $event">
  </summit-web-user-accounts>

  <div class="button-group">
    <button mat-flat-button color="primary" (click)="save()" [disabled]="!isUserValid || isAdding">Save and Close</button>
    <button mat-stroked-button color="primary" (click)="goBack()" class="cancel-button" >Back</button>
    <div style="overflow: hidden">
      <util-message [displayType]="'INLINE'"
                    [message]="!isUserValid ?
                                'Please fill out all required fields before submitting.' :
                                'You must choose '+saveDisabledText+' to associate with this user profile before submitting. Be sure to click Select and then Add.'"
                    [messageType]="'WARNING'"
                    [animationTrigger]="(!isUserValid || isAdding) ? 'INVALID' : 'VALID'"
                    [materialIconName]="'warning'">
      </util-message>
    </div>
  </div>
</ng-container>

<loading-animation *ngIf="isSubmitting" [loadingMessage]="'Saving...'"></loading-animation>

<util-message [displayType]="'SNACKBAR'"
              [message]="errorMessage"
              [animationTrigger]="errorMessage ? 'INVALID' : 'VALID'"
              [duration]="10000">
</util-message>
